import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common'
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { apisDataCacheKeys, studentDashboard } from '@app-constants/app.constants';
import { navigateBetweenProjects } from 'src/app/helpers/functions';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';

@Component({
  selector: 'app-score-new-thankyou',
  templateUrl: './score-new-thankyou.component.html',
  styleUrls: ['./score-new-thankyou.component.scss']
})
export class ScoreNewThankyouComponent implements OnInit {
  homeRoute = studentDashboard;
  public PaymentstatusUtility: any = {
    completedDetails: {},
    isultimatePackage: true,
    nextEmiOption: {}
  }
  public routingPage: any = '';
  public bactoHome: string = '/dashboard';
  constructor(public router: Router, public location: Location, public SubscriptionService: SubscriptionService,
    public testListService: TestlistService, public gaService: GAnalyticsService) {
    this.PaymentstatusUtility.completedDetails = this.router.getCurrentNavigation()?.extras;
    console.log('this.PaymentstatusUtility.completedDetails: ', this.PaymentstatusUtility.completedDetails);

    let userDetails: any = localStorage.getItem(apisDataCacheKeys.userDetails)
      ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))
      : {};

    if (this.PaymentstatusUtility?.completedDetails?.status == 'success') {
      localStorage.setItem(apisDataCacheKeys.payments, '');
      userDetails.email = '';
      userDetails.address = '';
      userDetails.state = '';
      userDetails.pincode = '';
      localStorage.setItem(apisDataCacheKeys.userDetails, JSON.stringify(userDetails));
    }

    this.PaymentstatusUtility.isultimatePackage = this.PaymentstatusUtility?.completedDetails?.productName?.toLowerCase().indexOf('ultimatate') == -1 ? true : false;
    let userInfo = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    console.log(userInfo)
    console.log(this.PaymentstatusUtility.completedDetails.completedDetails);
    console.log(this.PaymentstatusUtility.completedDetails);

    if (this.PaymentstatusUtility.completedDetails?.status) {
      if (this.PaymentstatusUtility.completedDetails?.status == 'success') {
        this.gaService.sendEvent(
          'Payment Completed',
          '',
          ``,
          ``,
          {
            'event': 'Payment Completed',
            'Phone Number': userInfo?.phone,
            'First Name': userInfo?.firstName,
            'Last Name': userInfo?.lastName,
            'City': '',
            'Email ID': userInfo?.email,
            'User Id': userInfo?.userId,
            'Course': this.PaymentstatusUtility?.completedDetails?.examname,
            'Course Duration': this.PaymentstatusUtility?.completedDetails?.numOfMonths,
            'Target Year': this.PaymentstatusUtility?.completedDetails[0]?.year,
          }
        );
        this.gaService.webEngageEvent({
          event: 'Buy Course Success',
          first_name: userInfo?.firstName,
          last_name: userInfo?.lastName,
          email: this.PaymentstatusUtility?.completedDetails?.prefill?.email

        });
        this.gaService.webEngageEvent({
          event: 'Payment Success',
          package_name: this.PaymentstatusUtility?.completedDetails?.packageName,
          amount: this.PaymentstatusUtility?.completedDetails?.planDetailsCapture?.paidAmount,
        });
        // this.gaService.webEngageEvent({
        //   event: 'Payment Success',
        //   package_name: this.PaymentstatusUtility?.completedDetails?.packageName,
        //   amount: this.PaymentstatusUtility?.completedDetails?.planDetailsCapture?.paidAmount,
        // });
        if(this.PaymentstatusUtility?.completedDetails?.scoreRegisterDetails?.source === 'score'){
          this.gaService.webEngageEvent({
            event: 'New Score22 Payment Success',
            first_name: userInfo?.firstName,
            last_name: userInfo?.lastName,
            email: this.PaymentstatusUtility?.completedDetails?.scoreRegisterDetails?.email,
            amount: this.PaymentstatusUtility?.completedDetails?.planDetailsCapture.paidAmount,
            page_url: window.location.href,
          });
        }
        this.gaService.webEngageEvent({
          event: 'Score22 Payment Success',
          page_url: window.location.href,
        });
      } else {
        this.gaService.webEngageEvent({
          event: 'Buy Course Failed',
          first_name: userInfo?.firstName,
          last_name: userInfo?.lastName,
          email: this.PaymentstatusUtility?.completedDetails?.prefill?.email,
          amount: this.PaymentstatusUtility?.completedDetails?.planDetailsCapture.paidAmount

        })
      }
      this.onPageLoad();
    }
    else {
      localStorage.setItem('SelectedTab', 'subscriptionPackages');
      this.routingPage = '/subscription/subscriptionPackages';
      navigateBetweenProjects(this.router, studentDashboard);
    }
  }
  

  ngOnInit(): void {
    localStorage.removeItem('logo-popup');
    console.log('PaymentstatusUtility: ', this.PaymentstatusUtility);
  }

  downloadInvoice(id) {
    this.SubscriptionService.downloadInvoice(id).subscribe((resp: any) => {
      const a = document.createElement('a')
      const objectUrl = URL.createObjectURL(resp)
      a.href = objectUrl
      let examName = this.PaymentstatusUtility.completedDetails?.examName || this.PaymentstatusUtility.completedDetails?.targetExam
      a.download = examName + 'invoice';
      a.click();
      URL.revokeObjectURL(objectUrl)

    })
  }
  onPageLoad() {
    if (this.PaymentstatusUtility?.completedDetails?.orderPlanResponseDto) {
      this.PaymentstatusUtility.nextEmiOption = this.PaymentstatusUtility?.completedDetails?.orderPlanResponseDto?.find(val => val.paymentStatus?.toLocaleLowerCase() == 'pending');
    } else {
      this.PaymentstatusUtility.nextEmiOption = this.PaymentstatusUtility?.completedDetails?.emiData?.find(val => (val.paidAmount == 0));
    }
  }

  getStarted() {
    this.router.navigate([`/dashboard/testlist/score`]);
    localStorage.removeItem('scoreData');
    localStorage.removeItem('rescheduleExamData');
  }

  hallticket(){
    this.router.navigate([`/download-hallticket`]);
    localStorage.removeItem('scoreData');
    localStorage.removeItem('rescheduleExamData');
  }

}
